import { memo, useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  updateBaseToken,
  updateCurrentConvertInfo,
  updateQuoteToken,
} from 'store/convert/actions'
import { useConvertBaseToken, useConvertQuoteToken } from 'store/convert/hooks'
import { SwitchCore, SwitchLine } from './style'
import { ReactComponent as SvgSwitch } from './assets/switch.svg'
import { styled } from '@mui/material'

const StyledSvgSwitch = styled(SvgSwitch)`
  color: #a0ee09;
  cursor: pointer;
  &:hover {
    color: #c7ff5c;
  }
`

export const SwitchSymbol = memo(() => {
  const dispatch = useDispatch()
  const baseToken = useConvertBaseToken()
  const quoteToken = useConvertQuoteToken()
  const [rotate, setRotate] = useState<boolean>(false)

  const onSwitch = useCallback(() => {
    setRotate(!rotate)
    dispatch(updateBaseToken({ ...quoteToken, amount: '' }))
    dispatch(updateQuoteToken({ ...baseToken, amount: '' }))
    dispatch(
      updateCurrentConvertInfo({
        baseAmount: '',
        quoteAmount: '',
        price: '',
        feeRate: 0,
        priceFrom: '',
        priceTo: '',
      }),
    )
  }, [rotate, quoteToken, baseToken])

  return (
    <SwitchCore>
      <SwitchLine />
      <StyledSvgSwitch onClick={onSwitch} />
      <SwitchLine />
    </SwitchCore>
  )
})
